<template>
  <div class="message-wrapper">
      <span @click="handleClose" class="close">&times;</span>
      <p>{{ messageAlert }}</p>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    width: {
      type: Number
    }
  },
  computed: {
    ...mapGetters(['messageAlert'])
  },
  methods: {
    ...mapActions(['closeMessage']),
    handleClose () {
      this.closeMessage()
    }
  }
}
</script>

<style lang="scss" scoped>
.close {
  font-size: 14px;
  color: #fff;
  top: 3px;
  right: 3px;
  position: absolute;
  cursor: pointer;
}
.message-wrapper {
    width: fit-content;
    max-width: 350px;
    height: 26px;
    line-height: 25px;
    font-size: 10px;
    color:#fff;
    background-color: #f9b11c;
    border-radius: 3px;
    padding: 0 10px 0 5px;
    position: relative;
    white-space: nowrap;

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/messageComponent/index.vue